import { useState, type FormEvent } from 'react'

export const MIN_PASSWORD_LENGTH = 6

interface Props {
	askName?: boolean
	submitLabel: string
	onSubmit(values: { name: string; password: string }): Promise<void>
}

/** New-password form shared by invite acceptance and password reset. */
export function PasswordForm({ askName = false, submitLabel, onSubmit }: Props) {
	const [name, setName] = useState('')
	const [password, setPassword] = useState('')
	const [confirm, setConfirm] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [busy, setBusy] = useState(false)

	async function submit(e: FormEvent) {
		e.preventDefault()
		if (password.length < MIN_PASSWORD_LENGTH) return setError(`Use at least ${MIN_PASSWORD_LENGTH} characters.`)
		if (password !== confirm) return setError('Passwords don’t match.')
		setBusy(true)
		setError(null)
		try {
			await onSubmit({ name, password })
		} catch (err) {
			setError((err as Error).message)
		} finally {
			setBusy(false)
		}
	}

	return (
		<form className="form" onSubmit={submit}>
			{askName && (
				<label className="field">
					Your name
					<input required autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} />
				</label>
			)}
			<label className="field">
				New password
				<input
					type="password"
					autoComplete="new-password"
					required
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
			</label>
			<label className="field">
				Confirm password
				<input
					type="password"
					autoComplete="new-password"
					required
					value={confirm}
					onChange={(e) => setConfirm(e.target.value)}
				/>
			</label>
			{error && (
				<p className="error small" role="alert">
					{error}
				</p>
			)}
			<button className="primary" type="submit" disabled={busy}>
				{submitLabel}
			</button>
		</form>
	)
}
